export const features = {
    "template": "template2",
    "companyName": "Barnstable County Mutual Insurance Company (Prod)",
    "inowEndpoint": "https://bmic.iscs.com",
    "tokenIssuer": "https://bmic-inow.okta.com/oauth2/default",
    "clientId": "0oa26n6eairF251Ak1d8",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": false,
        "affiliatedCarrierAccess": false,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "cancelFutureScheduledPayments": false,
        "changeCoverage": true,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": false,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": false,
        "companyDocuments": false,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "customerInformation": true,
        "deactivateUserOnly": true,
        "defaultLossDateTime": false,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2099-01-01",
        "mfaEnabled": false,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": false,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddress": true,
        "policyDetailsAddressTypeCd": [],
        "policyDocumentUpload": false,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": true,
        "printButtonEnabled": true,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": true,
        "scheduledPayments": false,
        "sendActivationEmail": false,
        "showCustomerDeliveryPreferences": true,
        "showImageTag": true,
        "showInstallPWA": false,
        "showPasswordToggle": false,
        "standardPhoneLength": false,
        "unauthenticatedPayments": false,
        "unauthenticatedReportClaim": false,
        "underlyingPoliciesPayPlansEditable": false,
        "useGooglePlacesInReportClaimFlow": true,
        "verifyAddress": true,
        "verifyFlow": true,
        "viewChangeRequests": true
    },
    "keys": {
        "googleAnalytics": "",
        "googleAnalytics4": null,
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": ""
    },
    "salesPortalUrl": "https://bmic-prod-cp.xi-1-us-west-2.guidewire.net",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js",
    "paymentTenantName": "tenant.bmic",
    "paymentConfigIds": {
        "BCIC": "31612203",
        "BCMIC": "31612202"
    },
    "paymentMethods": [
        "ACH",
        "CC"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC"
    ],
    "achEntryClassCode": "PPD",
    "attachmentTemplatesLimit": "20",
    "policiesCountLimit": "20",
    "billingAccountsCountLimit": "20",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Non-Renew Requested,Cancel Notice",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 7,
            "message": "Use at least 7 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2024-04-04T17:00-05:00",
        "endTime": "2024-04-04T17:00-05:00",
        "title": "<p>System Down for Maintenance</p>",
        "body": "<p>PLEASE NOTE: Due to a planned system upgrade, the Customer Service Portal will be unavailable on Thursday, April 4th, 2024 from 6:00 - 8:00 PM EDT. Please plan accordingly.</p>"
    },
    "signIn": {
        "title": "<p><h4>Welcome to the Barnstable Policyholder Portal!</h4></p>",
        "body": "<p>Welcome to our upgraded Policyholder Portal. You can use the portal to pay bills, review policy coverages, file claims online, and complete other insurance-related tasks quickly and easily.</p><p> To access the upgraded Policyholder Portal, all customers—new and existing—must select Create New Account and complete a one-time registration. Please have a recent declarations page or invoice available. You will need your policy number, the effective date of the current policy term, and the mailing ZIP code to register.</p><p>For enhanced security, the upgraded Policyholder Portal requires multifactor authentication (MFA) at every sign-in. After entering your username and password, you will receive a verification code by email that you must enter to complete the sign-in process.</p><p>Thank you for choosing The Barnstable. We appreciate your business!</p>"
    },
    "notificationSmsNumber": "",
    "billingStatusCd": "Normal, Cancel, Legal",
    "apiResponseSizeLimit": 100,
    "carrierDomains": {},
    "_meta": {
        "build": "4.0.0-7-8282893",
        "commit": "8282893c0ba818a166f19f821938feb0b89a9638",
        "company": "bmic",
        "date": "2026-09-16T14:30:23+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": "7"
    },
    "maxUploadFileSize": "500mb",
    "faviconFileExtension": "ico"
};